import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StateDeedOfSaleOfMotorVehicle.json';
import FormError from '../../../../view/FormError';
import Meta from '../../../../model/Meta';

class DeedOfSaleOfMotorVehicleStep1 extends Component {

	constructor(props) {
		super(props);
		this.state = Data;	
		this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
					//console.log("State default: ", this.state);
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));

					// Initialize errors and callbacks
					this.errorHandle();
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
			//console.log("State default: ", this.state);
			//console.log("Storage default: ", data);
		}

    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleChange(e, radioName=null) {

		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = radioName ? radioName : target.name;

		this.setState({
			details: {
				property: {
					...this.state.details.property,
					[name]: value
				},
				seller: this.state.details.seller,
				buyer: this.state.details.buyer
			},
			formFocus: `property_`+name
		},
			()=>{
				//console.log("Handle user change: ", this.state);
				//console.log("Focus target: ", this.state.formFocus+this.state.formFocussellerNo);
				this.setState(this.state);
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				this.errorHandle();

			}
		);
	}
	
	errorHandle(callback = null) {
		// Check if we have a user seller
		let errorArray = [];

		if(
			!this.state.details.property.make ||
			!this.state.details.property.mvFileNo ||
			!this.state.details.property.series ||
			!this.state.details.property.plateConductionNo ||
			!this.state.details.property.bodyType ||
			!this.state.details.property.engineNo ||
			!this.state.details.property.series ||
			!this.state.details.property.yearModel ||
			!this.state.details.property.chassisNo ||
			!this.state.details.property.certificateOfRegistrationNo
			){
			let err = {
				"message": `All fields are required.`
			}
			errorArray.push(err);
		}

		//console.log("Going to state: ", errorArray)

		this.setState({
			formError: errorArray
		},(i)=>{
			////console.log("Error handle: ", this.state )
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
			this.checkCompleteness();			
			this.state.details.seller.map((obj, i)=>this.elementsShowHide(i));			
		})
		
	}

    checkCompleteness() {

		if(this.state.formError.length>0) {
			$(".next").addClass("disabled");
		} else {
			$(".next").removeClass("disabled");
		}
			
	}

	elementsShowHide(i) {

		if(typeof this.state.details.seller[i] === 'undefined') {
			// Do nothing
		} else {

			/**
			 * Show/hide natural person block
			 */
			if(this.state.details.seller[i].legalPersonality==="Natural Person"){
				$(".seller_"+i+" .natural-person").removeClass("d-none");

				/**
				 * Hide everything else if seller is below legal age
				 */
				if(this.state.details.seller[i].isLegalAge==="Yes"){
					$(".seller_"+i+" .requireLegalAge").removeClass("d-none");
					$(".seller_"+i+" .isNotLegalAge").addClass("d-none");
				} else {
					$(".seller_"+i+" .requireLegalAge").addClass("d-none");
					$(".seller_"+i+" .isNotLegalAge").removeClass("d-none");
				}

				/**
				 * Hide representative if no representative
				 */
				if(
					this.state.details.seller[i].sellerHasRepresentative==="Yes" && 
					this.state.details.seller[i].isLegalAge==="Yes"){
					$(".seller_"+i+" .requireHasRepresentative").removeClass("d-none");
				} else {
					$(".seller_"+i+" .requireHasRepresentative").addClass("d-none");
				}

				/**
				 * Hide spouse block if single
				 */
				if(
					this.state.details.seller[i].isLegalAge==="Yes" && 
					this.state.details.seller[i].sellerMaritalStatus==="Married"){
					$(".seller_"+i+" .requireMarried").removeClass("d-none");
				} else {
					$(".seller_"+i+" .requireMarried").addClass("d-none");
				}


			} else {
				$(".seller_"+i+" .natural-person").addClass("d-none");
			}

			/**
			 * Show/hide corporation block
			 */
			if(this.state.details.seller[i].legalPersonality === "Corporation"){
				$(".seller_"+i+" .corporation").removeClass("d-none");
			} else {
				$(".seller_"+i+" .corporation").addClass("d-none");	
			}

			/**
			 * Hide error block if there is no error
			 */
			if(this.state.formError.length>0){
				////console.log("has error");
				$(".form-error").removeClass("d-none");
				$(".new-seller").addClass("d-none");
			} else {
				////console.log("no error");
				$(".form-error").addClass("d-none");
				$(".new-seller").removeClass("d-none");
			}

		}

	}

    render() {
				
			const meta = {
        title: "Vehicle particulars - Deed of Sale of Motor Vehicle Contract",
        description: "Enter vehicle's particulars - Create your custom Deed of sale of motor vehicle contract free"
			}
		
        return(
          <div className="page page-inner page-contract">
						<Meta {...meta}/>
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
								
                                <ContractCreate />
								
								<ProgressBar percentage={Math.floor((1/5)*100)} />

                                <form>

									<p>What are the particulars of the motor vehicle you are selling or buying?</p>
                                    
									<div className="form-group">
										<label htmlFor="make">
											<span className="font-weight-bold">Make: <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="make" type="text" onChange={this.handleChange} value={this.state.details.property.make} placeholder="(e.g. Honda)" />
									</div>

									<div className="form-group">
										<label htmlFor="mvFileNo">
											<span className="font-weight-bold">MV File number: <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="mvFileNo" type="text" onChange={this.handleChange} value={this.state.details.property.mvFileNo} placeholder="(e.g. 1234-1234567890)" />
									</div>

									<div className="form-group">
										<label htmlFor="series">
											<span className="font-weight-bold">Series: <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="series" type="text" onChange={this.handleChange} value={this.state.details.property.series} placeholder="(e.g. Civic RS)" />
									</div>	

									<div className="form-group">
										<label htmlFor="plateConductionNo">
											<span className="font-weight-bold">Plate / Conduction No.: <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="plateConductionNo" type="text" onChange={this.handleChange} value={this.state.details.property.plateConductionNo} placeholder="(e.g. ABC - 1234)" />
									</div>

									<div className="form-group">
										<label htmlFor="bodyType">
											<span className="font-weight-bold">Body Type: <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="bodyType" type="text" onChange={this.handleChange} value={this.state.details.property.bodyType} placeholder="(e.g. Sedan)" />
									</div>

									<div className="form-group">
										<label htmlFor="engineNo">
											<span className="font-weight-bold">Engine No.: <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="engineNo" type="text" onChange={this.handleChange} value={this.state.details.property.engineNo} placeholder="(e.g. 12345678A12B2)" />
									</div>

									<div className="form-group">
										<label htmlFor="yearModel">
											<span className="font-weight-bold">Year model: <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="yearModel" type="text" onChange={this.handleChange} value={this.state.details.property.yearModel} placeholder="(e.g. 2000)" />
									</div>

									<div className="form-group">
										<label htmlFor="chassisNo">
											<span className="font-weight-bold">Chassis No.: <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="chassisNo" type="text" onChange={this.handleChange} value={this.state.details.property.chassisNo} placeholder="(e.g. 1234-1234567890)" />
									</div>

									<div className="form-group">
										<label htmlFor="certificateOfRegistrationNo">
											<span className="font-weight-bold">Certificate of Registration No.: <span className="red asterisk">*</span></span>
										</label>
										<input className="form-control" name="certificateOfRegistrationNo" type="text" onChange={this.handleChange} value={this.state.details.property.certificateOfRegistrationNo} placeholder="(e.g. 1234567890)" />
									</div>

                                </form>

                                {/** Navs */}
								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 1/5</p>
									<FormError errors={this.state.formError} />
									<div className="row">
										<div className="col-6">
											<Link to={this.state.formPath} className="btn btn-lightblue w-100">Back</Link>
										</div>
										<div className="col-6">
											<Link to={this.state.formPath+"/2"} className="btn btn-lightblue disabled next w-100">Next</Link>
										</div>
									</div>
								</div>
                            
                            </div>

                            <div className="col-12 col-md-7 right-preview">
								<Preview {...this.state} />
							</div>
                         
                        </div>
                    </div>
                </div>
            </div>

        )
    }
    
}

export default DeedOfSaleOfMotorVehicleStep1;


// WEBPACK FOOTER //
// ./src/pages/contracts/business/deed-of-sale-of-motor-vehicle/DeedOfSaleOfMotorVehicleStep1.js